import { faSignature } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, lighten, Skeleton, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { CurrentUserDocumentToSignSummaryDTO } from "../../../../models/document-to-sign/current-user-document-to-sign-summary/current-user-dcument-to-sign-summary-dto";

const MyDocumentsToSignLink = ({
  customSummary,
  loading,
}: {
  customSummary: CurrentUserDocumentToSignSummaryDTO;
  loading: boolean;
}) => {
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const tRP = "components.custom_widget_links.document_signature";
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      {currentUserAuthorizations?.canAccessDocumentToSign?.asSignatory ? (
        <Grid
          style={{
            display: "flex",
            border: `1px solid ${theme.palette.warning.main}`,
            borderRadius: "8px",
            padding: "15px",
            color: theme.palette.warning.main,
            backgroundColor: lighten(theme.palette.warning.main, 0.9),
            position: "relative",
            gap: "5px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              color: theme.palette.warning.main,
              fontSize: "28px",
            }}
          >
            {loading ? (
              <Skeleton
                width={"40px"}
                height={"100%"}
                variant="rectangular"
              />
            ) : (
              customSummary.requestsToMe ?? 0
            )}
          </Typography>
          <Typography>{`${t(`${tRP}.signatory_note`)}`}</Typography>

          <Grid
            style={{
              display: "flex",
              borderRadius: "20px",
              color: theme.palette.primary.contrastText,
              backgroundColor: lighten(theme.palette.warning.main, 0.4),
              position: "absolute",
              right: "12px",
              justifyContent: "center",
              alignItems: "center",
              top: "-17px",
              fontSize: "20px",
              width: "35px",
              height: "35px",
            }}
          >
            <FontAwesomeIcon icon={faSignature} />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default MyDocumentsToSignLink;
